export function useCountdown(targetDate: string, onTick: (remaining: { days: number; hours: number; minutes: number; seconds: number }) => void) {
  function calculateRemaining() {
    const now = new Date().getTime()
    const end = new Date(targetDate).getTime()
    const diff = end - now

    if (diff <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 }
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((diff % (1000 * 60)) / 1000)

    return { days, hours, minutes, seconds }
  }

  onTick(calculateRemaining())

  const interval = setInterval(() => {
    const remaining = calculateRemaining()
    onTick(remaining)

    if (
      remaining.days === 0 &&
      remaining.hours === 0 &&
      remaining.minutes === 0 &&
      remaining.seconds === 0
    ) {
      clearInterval(interval)
    }
  }, 1000)
  return () => clearInterval(interval)
}